import React from "react";

import { Stack } from "@mui/material";

import useFartherEmployees from "@fartherfinance/frontend/api/Entity/hooks/useFartherEmployees";
import { PersonId } from "@fartherfinance/frontend/api/Investment/types";

import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import Checkbox from "@src/sharedComponents/Checkbox/Checkbox";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";

import { useAccessContext } from "./AccessContextProvider";

type GenericHappyPath = {
  displayName: string;
  onCheckBoxChange: () => void;
  accessGranted: boolean;
};

type RowState = GenericHappyPath;

const AdvisorRowPermission = (props: RowState) => {
  const auth = useAdvisorRequestAuth();
  const data = useFartherEmployees("All", auth);

  const advisorInfo = data.data?.advisors.find(
    (advisor) => advisor.advisorId === props.displayName
  );

  if (advisorInfo === undefined) {
    return <LoadingCheckboxRow />;
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      width={"100%"}
      justifyContent={"space-between"}
      flex={1}
      paddingBottom={"8px"}
      paddingTop={"8px"}
    >
      <Stack direction="row">
        <Checkbox
          label={`${advisorInfo?.name.first}  ${advisorInfo?.name.last}`}
          checked={props.accessGranted}
          onChange={props.onCheckBoxChange}
        />
      </Stack>
      <Text
        style={{ alignContent: "center" }}
        variant="body"
        color={props.accessGranted ? "text" : "textSubtle"}
      >
        {props.accessGranted ? "Access granted" : "No access"}
      </Text>
    </Stack>
  );
};

type Resp = {
  personId: PersonId;
  allowed: boolean;
};

type ExpandableRowProps = {
  isLoading: boolean;
  data: Resp[];
};

const ExpandableRowsAccordion = (props: ExpandableRowProps) => {
  const { advisorHash, advisorCheckBox } = useAccessContext();

  if (props.isLoading) {
    return <LoadingCheckboxRow />;
  }

  return (
    <>
      {props.data.map((check) => (
        <AdvisorRowPermission
          key={check.personId}
          displayName={check.personId}
          onCheckBoxChange={advisorCheckBox(check.personId, check.allowed)}
          accessGranted={
            typeof advisorHash[check.personId] === "boolean"
              ? advisorHash[check.personId]
              : check.allowed
          }
        />
      ))}
    </>
  );
};

export default ExpandableRowsAccordion;

const LoadingCheckboxRow = () => (
  <Stack
    direction={"row"}
    spacing={2}
    justifyContent={"space-between"}
    width={"100%"}
    flex={1}
  >
    <Skeleton width={220} />
    <Skeleton width={100} />
  </Stack>
);
